//import axios from 'axios';
//import authHeader from './auth-header';
import api from "./api";//Added 2024-04-18 for refreshToken

class PlaylistTuneDataService {
    getAll(data) {
        //return axios.get(process.env.VUE_APP_ROOT_API + "playlisttunes", { headers: authHeader(), params: data }); //Replaced 2024-04-18 due to RefreshToken
        return api.get("playlisttunes", { params: data });
    }

    update(id, data) {
        //console.log(id);
        //console.log(data);
        //return axios.put(process.env.VUE_APP_ROOT_API + `playlisttunes/${id}`, data, { headers: authHeader() }); //Replaced 2024-04-18 due to RefreshToken
        return api.put(`playlisttunes/${id}`, data);
    }

    delete(id, data) {
        //return axios.delete(process.env.VUE_APP_ROOT_API + `playlisttunes/${id}`, { headers: authHeader(), data }); //Replaced 2024-04-18 due to RefreshToken
        return api.delete(`playlisttunes/${id}`, { data })
    }
}

export default new PlaylistTuneDataService();